"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageText = exports.Retry = exports.ErrorMessage = void 0;
var faRedo_1 = require("@fortawesome/free-solid-svg-icons/faRedo");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var getMessage = function (_a) {
    var content = _a.content, error = _a.error;
    if (error) {
        return 'An error has occurred.';
    }
    return "Failed to load".concat(content, ".");
};
var ErrorMessage = function (props) {
    var className = props.className, _a = props.content, content = _a === void 0 ? '' : _a, error = props.error, reload = props.reload;
    var message = getMessage({ content: content, error: error });
    return (react_1.default.createElement(MessageWrapper, { className: className },
        react_1.default.createElement(exports.MessageText, null, message),
        react_1.default.createElement(exports.Retry, { onClick: reload },
            "Click to retry",
            react_1.default.createElement(RetryIcon, { icon: faRedo_1.faRedo, "aria-hidden": "true" }))));
};
exports.ErrorMessage = ErrorMessage;
var MessageWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 874px;\n  text-align: center;\n  font-size: 1.5rem;\n"], ["\n  width: 100%;\n  min-height: 874px;\n  text-align: center;\n  font-size: 1.5rem;\n"])));
exports.Retry = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-top: 12px;\n  font-size: initial;\n  cursor: pointer;\n  font-weight: 700;\n  color: ", ";\n"], ["\n  padding-top: 12px;\n  font-size: initial;\n  cursor: pointer;\n  font-weight: 700;\n  color: ", ";\n"])), function (props) { return props.theme.primary3; });
var RetryIcon = (0, styled_components_1.default)(react_fontawesome_1.FontAwesomeIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-left: 5px;\n  font-size: 1.15rem;\n  color: ", ";\n"], ["\n  padding-left: 5px;\n  font-size: 1.15rem;\n  color: ", ";\n"])), function (props) { return props.theme.primary3; });
exports.MessageText = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-top: 75px;\n  color: ", ";\n"], ["\n  padding-top: 75px;\n  color: ", ";\n"])), function (props) { return props.theme.primary3; });
exports.default = exports.ErrorMessage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
